"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasOwnProperty;
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/form/DatePicker/Toolbox/utils/hasOwnProperty.js
// module id = 524
// module chunks = 0